import { createSlice } from "@reduxjs/toolkit";

const profileSlice = createSlice({
  name: "Business",
  initialState: {
    contactDetails: {},
    rejectedVerfication: false,
    profileDetails: {},
  },
  reducers: {
    setContactDetails(state, action) {
      state.contactDetails = { ...action.payload };
    },
    setRejectionVerification(state, action) {
      state.rejectedVerfication = action.payload;
    },
  },
});

export const profileSliceActions = profileSlice.actions;

export default profileSlice.reducer;
